import React from "react"
import withStyles from "react-jss"
import colors from "../data/colors"

const styles = {
  container: {
    position: "relative",
    textAlign: "center",
    width: "100px",
    height: "50px",
  },
  dot1: {
    display: "inline-block",
    width: "6px",
    height: "6px",
    borderRadius: "50%",
    background: colors.black,
    marginRight: "4px",
    animation: "$wave 1.3s linear infinite",
  },
  dot2: {
    composes: "$dot1",
    animationDelay: "-1.1s",
  },
  dot3: {
    composes: "$dot1",
    animationDelay: "-0.9s",
  },
  "@keyframes wave": {
    "0%, 60%, 100%": {
      transform: "initial",
    },
    "30%": {
      transform: "translateY(-10px)",
    },
  },
}

const JumpingDots = ({ classes }) => {
  return (
    <span className={classes.wave}>
      <span className={classes.dot1}></span>
      <span className={classes.dot2}></span>
      <span className={classes.dot3}></span>
    </span>
  )
}

export default withStyles(styles)(JumpingDots)
